import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentLogo, selectPartnerVariant, selectPartnerConfig, selectIsPartner } from "../../Redux/selectors/brandingSelectors";
import LianLianBrandingPanel from "../Partner/LianLianBrandingPanel";
import { ONBOARDING_VARIANT } from "../Partner/onboardingConstants";

export default function OnboardingBranding() {
    const isPartner = useSelector(selectIsPartner);
    const variant = useSelector(selectPartnerVariant);
    const config = useSelector(selectPartnerConfig);
    const logoToShow = useSelector(selectCurrentLogo);

    if (!isPartner) {
        return <img className="logo-login" src={logoToShow} alt="Logo" />;
    }

    switch (variant) {
        case ONBOARDING_VARIANT.LIANLIAN:
            return (
                <LianLianBrandingPanel
                    productName={config.productName}
                    coBrandingText={config.coBrandingText}
                    logoSrc={logoToShow}
                />
            );

        default:
            return <img className="logo-login" src={logoToShow} alt="Logo" />;
    }
}
